module.exports = __webpack_public_path__ + "static/img/img6.3a7b98f5.png";